<template>
  <v-dialog
    v-model="dialog"
    width="600"
  >
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <div
            class="info--text"
            v-text="title"
          />
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn
            icon
            @click="dialog = false"
          >
            <v-icon>{{ mdiClose }}</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-divider class="mx-3" />
      <v-card-text>
        <slot name="feedback" />
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col
            cols="12"
            sm="8"
            offset="2"
            md="4"
            offset-md="4"
          >
            <v-btn
              block
              depressed
              :color="color"
              @click="dialog = false"
            >
              <span v-text="$t('labels.close')" />
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js';

export default {
  name: 'BaseModalFeedback',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: '',
      note: 'The modal title',
    },
    color: {
      type: String,
      default: 'info',
      note: 'The confirm button color',
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  created() {
    this.mdiClose = mdiClose;
  },
};
</script>
